// extracted by mini-css-extract-plugin
export default {"switchWrapper":"style_switchWrapper__nzESN","switchLabel":"style_switchLabel__NIj5A","uncheckedIcon":"style_uncheckedIcon__zBRwx","checkedIcon":"style_checkedIcon__a6h2L"};